import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=31b5b204&"
import script from "./ServiceHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b5b204')) {
      api.createRecord('31b5b204', component.options)
    } else {
      api.reload('31b5b204', component.options)
    }
    module.hot.accept("./ServiceHelp.vue?vue&type=template&id=31b5b204&", function () {
      api.rerender('31b5b204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fswtg47njH3X/JS/comp/ServiceHelp.vue"
export default component.exports